import React from "react";
import PhoneCallWithOtp from "screens/VAPI Ai/phoneCalling/PhoneCallWithOtp";
import InterviewAssistant from "screens/VAPI Ai/VAPIClient";
import VapiWidget from "screens/VAPI Ai/VAPIwidget";

const VoiceAgent = ({ typeOfAgent = "", version = 1 }) => {
  const pubicKey = process.env.REACT_APP_VAPI_PUBLIC_KEY;
  const assistantId = process.env.REACT_APP_VAPI_ASSISTANT_ID;
  const squadId = process.env.REACT_APP_VAPI_SQUAD_ID; // CRAI Squad
  const tenantId = process.env.REACT_APP_FORM_API_TENANT;
  const phoneNumberId = process.env.REACT_APP_VAPI_PHONE_NUMBER_ID;

  const singleAssistantId = "a27cb51a-d4d7-4111-b996-d7623c3a5010"; // not adding it to the ENV file as it's for demo purpose and getting changed frequently

  return (
    <div className="h-100">
      {/* <VapiWidget assistantId={"assistantId"} publicKey={"pubicKey"} /> */}
      {
        typeOfAgent === "web" ?
          <InterviewAssistant assistantId={version === 4 ? singleAssistantId : assistantId} publicKey={pubicKey} version={version} />
          : typeOfAgent === "phone" ? <PhoneCallWithOtp squadId={squadId} tenantId={tenantId} phoneNumberId={phoneNumberId} /> : null
      }
    </div>
  );
};

export default VoiceAgent;
